import { render, staticRenderFns } from "./ConcertsList.vue?vue&type=template&id=3f77bece&"
import script from "./ConcertsList.vue?vue&type=script&lang=js&"
export * from "./ConcertsList.vue?vue&type=script&lang=js&"
import style0 from "./ConcertsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports